export default __webpack_public_path__ + "static/media/resume.b02b2c1b.pdf";